import { lazy } from "react";

const ModuleSortingLogsPage = lazy(
  () => import("../wms/pages/module-sorting/logs")
);
const ModuleSortingListPage = lazy(
  () => import("../wms/pages/module-sorting/list")
);

export const ModuleSortingRoutes = [
  { path: "p2l-log", element: <ModuleSortingLogsPage /> },
  { path: "list", element: <ModuleSortingListPage /> }
];
export default ModuleSortingRoutes;
